export const calculateImageBackgroundSize = (
  originalImageWidth: number,
  originalImageHeight: number,
  puzzleImageWidth: number,
  puzzleImageHeight: number,
  scaleFactor = 1
): string => {
  return originalImageWidth <= originalImageHeight
    ? `${puzzleImageWidth * scaleFactor}px auto`
    : `auto ${puzzleImageHeight * scaleFactor}px`;
};

export const calculateImageBackgroundPosition = (
  originalImageWidth: number,
  originalImageHeight: number,
  puzzleImageWidth: number,
  puzzleImageHeight: number,
  puzzleImageSlice: { x: number; y: number },
  scaleFactor = 1
): string => {
  return originalImageWidth > originalImageHeight
    ? `${
        scaleFactor *
        (puzzleImageSlice.x -
          ((puzzleImageHeight * originalImageWidth) / originalImageHeight - puzzleImageWidth) / 2)
      }px ${puzzleImageSlice.y * scaleFactor}px`
    : `${puzzleImageSlice.x * scaleFactor}px ${
        scaleFactor *
        (puzzleImageSlice.y -
          ((puzzleImageWidth * originalImageHeight) / originalImageWidth - puzzleImageHeight) / 2)
      }px`;
};
